<template>
  <aside class="app-sidebar">
    <AppSidebarContent />
  </aside>
</template>

<script>
import AppSidebarContent from './AppSidebarContent.vue'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarContent
  }
}
</script>

<style scoped>
.app-sidebar {
  position: fixed;
  left: 0;
  top: 64px;
  bottom: 0;
  width: 208px;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-right: 1px solid #f0f0f0;
  overflow: hidden;
  z-index: 999;
}

.app-sidebar > :deep(.sidebar-inner) {
  flex: 1;
  min-height: 0;
  width: 100%;
}

.sidebar-nav {
  padding: 16px 0;
}

.menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  text-align: left;
  line-height: 1.5;
}

.menu-item:hover {
  background-color: #fafafa;
}

.menu-item-disabled {
  opacity: 0.5;
  color: rgba(0, 0, 0, 0.25) !important;
}

.menu-item-disabled .menu-label {
  color: rgba(0, 0, 0, 0.25) !important;
}

.menu-item-disabled .menu-icon {
  color: rgba(0, 0, 0, 0.25) !important;
}

.menu-item-disabled:hover {
  background-color: #fafafa;
}

.menu-item-active {
  background-color: #e6f7ff;
  color: #1890ff;
}

.menu-item-active .menu-label {
  color: #1890ff;
}

.menu-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #1890ff;
}

.menu-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-label {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.85);
}

/* Pad 设备优化 - 侧边栏可以折叠或隐藏 */
@media (max-width: 1024px) {
  .app-sidebar {
    width: 180px;
  }
  
  .menu-item {
    padding: 10px 20px;
    font-size: 13px;
  }
}

/* 移动端隐藏侧边栏 */
@media (max-width: 767px) {
  .app-sidebar {
    display: none;
  }
}
</style>

